module.exports = __webpack_public_path__ + "img/program-jfcc.becde6b2.png";